import React, { useEffect, useState } from 'react';
import { useAuthenticated, useTranslate, Title, useDataProvider } from 'react-admin';
import moment from 'moment-timezone';
import { Box, Typography, Grid, ListItem, Button, Card, FormControlLabel, CircularProgress, TextField } from '@material-ui/core';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar'
import { makeStyles } from "@material-ui/core/styles";
import StartCalendar from '../common/DatePicker/startCalendar'
import StopCalenrar from '../common/DatePicker/stopCalendar'
import colors from '../CustomizedUIs/Colors'
import TableFiles from './tableSeverLog';
import Error from '../CustomizedUIs/Error'
import TimePicker from '../common/TimePicker'


import {
  useMediaQuery
} from '@material-ui/core';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  },
  TitleSeverlog: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '18px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#4f5064',
  },
  TitleDateTime: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '11px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#4f5064',
  },
  TitleTime: {
    fontFamily: 'UniviaPro',
    fontSize: '11px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.36,
    letterSpacing: 'normal',
    color: '#88898c',
  },
  Time: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: '0.13px',
    color: '#4f5064',
  },
  Text: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: ' 0.13px',
    color: '#4f5064',
  },
  btnSelect: {
    fontFamily: 'UniviaPro',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.44px',
    color: '#ffffff',
  }

});

const ServerLog = () => {
  const [valueStartTime, setValueStartTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateStart, setDateStart] = useState(new Date());
  const date = new Date();
  date.setHours(23, 59, 59)
  const [valueStopTime, setValueStopTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateStop, setDateStop] = useState(date);
  const [oldDateStop, setOldDateStop] = useState(date);
  const [oldDateStart, setOldDateStart] = useState(new Date());
  const [anchorElStopCalendar, setAnchorElStopCalendar] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElStartCalendar, setAnchorElStartCalendar] = React.useState(null);
  const [openPoper, setOpenPopper] = React.useState(false);
  const [noEndDate, setNoEndDate] = useState(false)
  const [logLevel, setLogLevel] = useState("");
  const [openLogLevel, setOpenLogLevel] = useState(false);
  const dataProvider = useDataProvider();
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
  const [data, setData] = useState([]);
  const translate = useTranslate();
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true)
  const [currentPage, setCurentPage] = useState(1)
  const [notPermission, setNotPermission] = useState(false);
  const [notdata, setNoData] = useState(true);
  const [openTimePickerStart, setOpenTimePickerStart] = useState(false)
  const [openTimePickerStop, setOpenTimePickerStop] = useState(false)


  useAuthenticated();
  const classes = useStyles();
  const onChangeLogLevel = (value) => {
    setLogLevel(value)
    setOpenLogLevel(false)
  }

  const handleClickOpenLogLevel = () => {
    setOpenLogLevel(!openLogLevel)
  }

  const handleClickOpenPoper = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopper(true);
  };

  const handleClosePoper = () => {
    setOpenPopper(false);
  };



  const SearchLog = () => {
    setLoading(true)
    setData([])
    let startdate = dateStart.getTime();
    let stopdate = dateStop.getTime() + 999;
    let level = logLevel.toLowerCase();
    dataProvider('GET_LIST', 'ServerInfo/log', {
      filter: {

        from: startdate,
        to: stopdate,
        level: level,
        page: 0,
        serverLog: true

      },
      pagination: {},
      sort: {},

    }).then((response) => {
      if (response.data.length === 0) {
        setNoData(false);
      } else {

        setNoData(true);
      }
      setData(response.data);
      setHasMore(true)
      setLoading(false);
      setCurentPage(1)
    }).catch(error => {
      if (error.message === 'permissionIncorect') {
        setNotPermission(true)
      }
      setLoading(false)
      // TODO: Should show error message 
      console.log('Submit user error:', error);
    });
  }
  //event select of Stop Calendar

  const loadMore = () => {
    let startdate = dateStart.getTime();
    let stopdate = dateStop.getTime() + 999;
    let level = logLevel.toLowerCase();
    dataProvider('GET_LIST', 'ServerInfo/log', {
      filter: {

        from: startdate,
        to: stopdate,
        level: level,
        page: currentPage,
        serverLog: true

      },
      pagination: {},
      sort: {},

    }).then((response) => {
      if (response.data.length === 0)
        setHasMore(false)
      else {
        setData(data.concat(response.data));
        setCurentPage(currentPage + 1)
      }

    }).catch(error => {
      setHasMore(false)
      // TODO: Should show error message 
      console.log('Submit user error:', error);
    });
  }

  const handleClickStopCalendar = (event) => {
    if (anchorElStopCalendar == null) {
      setAnchorElStopCalendar(event.currentTarget)
    }
    else {
      handleCloseStopCalendar()
      setAnchorElStopCalendar(null)
    }

  };

  const handleCloseStopCalendar = () => {
    setDateStop(oldDateStop)
    setAnchorElStopCalendar(null);
    setNoEndDate(valueStopTime == translate(`resources.room.onGoing`))
  };


  const onChangNoEndDate = (e) => {
    setNoEndDate(e.target.checked)
  }



  const finishPickDateStop = (date) => {
    setValueStopTime(noEndDate ? translate(`resources.room.onGoing`) : moment(date).format('YYYY-MM-DD'))
    setOldDateStop(date)
    setAnchorElStopCalendar(null);
  };

  const onChangeStopCalendar = (date) => {
    setDateStop(date)
    finishPickDateStop(date)
    setOpenTimePickerStart(false)
  }
  //----------------------
  //event select of Start Calendar

  const handleClickStartCalendar = (event) => {
    if (anchorElStartCalendar == null)
      setAnchorElStartCalendar(event.currentTarget)
    else {
      handleCloseStartCalendar()
      setAnchorElStartCalendar(null)
    }
  };

  const handleCloseStartCalendar = () => {
    setDateStart(oldDateStart)
    setAnchorElStartCalendar(null);
  };

  const finishPickDate = (date) => {
    setValueStartTime(moment(date).format('YYYY-MM-DD'))
    if (date.getTime() > dateStop.getTime() && valueStopTime != translate(`resources.room.onGoing`)) {
      setDateStop(date)
      setValueStopTime((moment(date).format('YYYY-MM-DD')))
    }
    setOldDateStart(date)
    setAnchorElStartCalendar(null);
  };

  const onChangeStartCalendar = (date) => {
    setDateStart(date)
    finishPickDate(date)
    setOpenTimePickerStart(false)
  }

  //----------------------
  const onChangePickerStart = (e) => {
    let timeStart = (e.target.value).split(':')
    let newDateStart = dateStart
    newDateStart.setHours(timeStart[0], timeStart[1], timeStart[2])
    setDateStart(newDateStart)
  }

  const onChangePickerStop = (e) => {
    let timeStop = (e.target.value).split(':')
    let newDateStop = dateStop
    newDateStop.setHours(timeStop[0], timeStop[1], timeStop[2])
    setDateStop(newDateStop)
  }

  const formatTime = (times) => {
    if (!times) {
      return '';
    }

    return moment(times).format('HH:mm:ss');
  };
  if (notPermission) return <Error />
  return (
    <Box width="100%">
      <Title title="{translate(`pos.user.title`)}" />
      <Box display='flex' width='100%' justifyContent='center'>
        <Box my={2} style={{ width: "500px" }} >
          <Typography className={classes.TitleSeverlog} style={{ margin: 'auto 0' }}>{translate('resources.severlog.severlog')}</Typography>
          <Box display='flex'
            justifyItems='center'
            py={2} my={1}
            bgcolor={colors.white['50']}
            border={1}
            borderColor={colors.lightBlue['200']}
            borderRadius='4px' >
            <Box mx='auto' width='469px' >
              <Typography style={{ paddingBottom: 8 }} className={classes.TitleDateTime}>{translate(`resources.severlog.datestartstop`)}</Typography>
              <Grid container justify="space-between" alignItems="flex-end">
                <Grid item style={{ width: '207px' }}>
                  <StartCalendar
                    anchorEl={anchorElStartCalendar}
                    handleClick={handleClickStartCalendar}
                    handleClose={handleClickStartCalendar}
                    handleDateChange={onChangeStartCalendar}
                    finishPickDate={finishPickDate}
                    value={valueStartTime}
                    date={dateStart}
                    Title={translate(`resources.room.from`)}
                  />
                </Grid>
                <Grid item style={{ width: '207px' }}>
                  <StopCalenrar
                    isNoEndDate={noEndDate}
                    onChangNoEndDate={onChangNoEndDate}
                    minDate={valueStartTime}
                    anchorEl={anchorElStopCalendar}
                    handleClick={handleClickStopCalendar}
                    handleClose={handleClickStopCalendar}
                    handleDateChange={onChangeStopCalendar}
                    finishPickDate={finishPickDateStop}
                    value={valueStopTime}
                    date={dateStop}
                    Title={translate(`resources.room.to`)}
                  />
                </Grid>
                <Grid item>
                  <CustomPoper
                    isNotInfoPage={true}
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`resources.severlog.title`)}
                    content={translate(`resources.severlog.content`)}
                    icon={<b>?</b>}
                  />
                </Grid>
              </Grid>{

              }
              <Card style={{ marginTop: "1em", borderRadius: '0', width: '300px', height: '36px' }} >
                <FormControlLabel
                  control={<Box alignItems="center" ml={2} display="flex">
                    <TextField
                      id="time"
                      type="time"
                      defaultValue="00:00"
                      onChange={onChangePickerStart}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 1, // 1 second,
                        className: classes.Time
                      }}

                    />

                    <Typography style={{ paddingLeft: 8, paddingRight: 8 }} className={classes.Time} >-</Typography>
                    <TextField
                      id="time"
                      type="time"
                      defaultValue="00:00"
                      onChange={onChangePickerStop}
                      className={{
                        // marginLeft: theme.spacing.unit,
                        // marginRight: theme.spacing.unit,
                        width: 200,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 1, // 1 second
                        className: classes.Time
                      }} />

                  </Box>}
                  label={<Typography className={classes.TitleTime}>Time</Typography>}
                  style={{ marginTop: "8px", color: "#88898c" }}
                  labelPlacement="start"
                />
                {/* <TimePicker
                  openTimePicker={openTimePickerStart}
                  handleClick={handleClickStartCalendar}
                  setOpenTimePicker={setOpenTimePickerStart}
                  handleDateChange={onChangeStartCalendar}
                  finishPickDate={finishPickDate}
                  value={valueStartTime}
                  date={dateStart}
                />
                <TimePicker
                  openTimePicker={openTimePickerStop}
                  minDate={valueStartTime}
                  handleClick={handleClickStopCalendar}
                  setOpenTimePicker={setOpenTimePickerStop}
                  handleDateChange={onChangeStopCalendar}
                  finishPickDate={finishPickDateStop}
                  value={valueStopTime}
                  date={dateStop}

                /> */}
              </Card>
            </Box>

          </Box>

          <Box pt={1} pb={0} mt={1} >
            <SelectBox
              label={translate('resources.severlog.loglevel')}
              value={<Typography className={classes.Text}>{logLevel === "" ? "All" : logLevel}</Typography>}
              open={openLogLevel}
              handleClick={handleClickOpenLogLevel}
            >
              <Box className={classes.boxBoder}>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel("")}>
                  <Typography className={classes.Text}>{translate('resources.severlog.all')}</Typography>
                </ListItem>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel(translate('resources.severlog.error'))}>
                  <Typography className={classes.Text}>{translate('resources.severlog.error')}</Typography>
                </ListItem>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel(translate('resources.severlog.debug'))}>
                  <Typography className={classes.Text}>{translate('resources.severlog.debug')}</Typography>
                </ListItem>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel(translate('resources.severlog.info'))}>
                  <Typography className={classes.Text}>{translate('resources.severlog.info')}</Typography>
                </ListItem>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel(translate('resources.severlog.warn'))}>
                  <Typography className={classes.Text}>{translate('resources.severlog.warn')}</Typography>
                </ListItem>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel(translate('resources.severlog.silent'))}>
                  <Typography className={classes.Text}>{translate('resources.severlog.silent')}</Typography>
                </ListItem>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel(translate('resources.severlog.verbose'))}>
                  <Typography className={classes.Text}>{translate('resources.severlog.verbose')}</Typography>
                </ListItem>
                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLogLevel(translate('resources.severlog.silly'))}>
                  <Typography className={classes.Text}>{translate('resources.severlog.silly')}</Typography>
                </ListItem>
              </Box>
            </SelectBox>
          </Box>
          <Box mt={3} display='flex' justifyContent='flex-end'>
            <Button
              disabled={loading}
              mt={3} variant="contained" color='primary' style={{ width: '94px', height: '36px' }} onClick={SearchLog}
            >
              {loading ? (
                <CircularProgress
                  size={20}
                  thickness={2}
                  color='inherit'
                />
              ) : <Typography className={classes.btnSelect}>{translate('resources.severlog.select')}</Typography>}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box style={{ padding: 63 }} >
        {
          notdata === false ?
            <Box display='flex' width='100%' justifyContent='center'>
              <Typography style={{ textAlign: 'center', padding: 30 }} className={classes.TitleSeverlog}>{translate('resources.severlog.nodata')}</Typography>
            </Box>
            :
            data.length != 0 &&
            <TableFiles
              loadFunc={loadMore}
              hasMore={hasMore}
              categories={data}
            />
        }
      </Box>
    </Box>

  );
};

export default ServerLog;
